import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type FadeInProps = {
  children: ReactNode;
  className?: string;
  delay?: number;
};

export const FadeIn: FC<FadeInProps> = ({ children, className, delay = 0 }) => (
  <div
    className={twMerge('animate-reveal-up', className)}
    style={delay ? { animationDelay: `${delay}s` } : undefined}
  >
    {children}
  </div>
);
